export default "__VITE_ASSET__DNWurYxt__"